<div class="user-dropdown">
  <button
    ds-button variant="ghost"
    icon="arrow_down_small"
    class="user-button"
    (click)="toggleUserDropdown()">{{ user.getName() }}
  </button>
  @if (viewState().userDropdownVisible) {
    <ds-box>
      <ds-box-content spacing="sm">
        <ds-list-item icon="user_settings" [isHoverable]="true"
                      (click)="openSettings()"
                      (keydown.enter)="openSettings()"
                      (keydown.space)="$event.preventDefault(); openSettings()">{{ 'user.settings' | translate }}
        </ds-list-item>
        <ds-list-item icon="logout" [isHoverable]="true"
                      (click)="logOut()"
                      (keydown.enter)="logOut()"
                      (keydown.space)="$event.preventDefault(); logOut()">{{ 'user.logout' | translate }}
        </ds-list-item>
      </ds-box-content>
      <ds-box-content spacing="sm" divider="full" class="user-dropdown-footer">
        <p class="text-smallprint">AWP {{ supportInformationService.awpVersion }}</p>
        <a class="text-smallprint"
           (click)="copySupportInformation()">{{ 'user.copySupportInformation' | translate }}</a>
        @if (copyAccessTokenVisible()) {
          <a class="text-smallprint" (click)="copyAccessToken()">Copy access token</a>
        }
        <p class="text-smallprint">© Copyright {{ getCurrentYear() }} BMW Group</p>
      </ds-box-content>
    </ds-box>
  }
</div>

@if (viewState().userDropdownVisible) {
  <div class="user-dropdown-outside-area"
       (click)="closeUserDropdown()"
       (window:keydown.escape)="closeUserDropdown()"></div>
}

<app-user-settings-overlay [state]="viewState()"/>
